import React from 'react';
import { useRecordContext } from 'react-admin';
import { Chip, Stack } from '@mui/material';

function TagChipField({ source, ...props }) {
  const record = useRecordContext() || {};
  const tags = record[source];

  if (!tags || tags.length === 0) {
    return '-';
  }

  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" gap={0.5}>
      {tags.map((tag, index) => (
        <Chip
          {...props}
          key={index}
          label={tag}
          size="small"
          variant="outlined"
          color="primary"
          sx={{
            fontSize: '0.7rem',
            height: '20px',
            '& .MuiChip-label': {
              px: 1,
            },
          }}
        />
      ))}
    </Stack>
  );
}

export default TagChipField;
